import React from 'react';
import PropTypes from 'prop-types';
import { ConfigProvider } from 'antd';
import { ThemeProvider } from 'styled-components';

const theme = {
  token: {
    colorPrimary: '#c12b7d',
    secondaryColor: '#ffffff'
  }
};
function Theme({ children }) {
  // console.log(2222, theme);
  return (
    <ConfigProvider theme={theme}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ConfigProvider>
  );
}

Theme.propTypes = {
  children: PropTypes.element.isRequired
};

export default Theme;
